<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import Textarea from '$components/Form/Textarea.svelte';
    import Select from '$components/Form/Select.svelte';
    import MeltMultiSelect from '$components/Form/MeltMultiSelect.svelte';
    import find from 'lodash/find';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const youAreOptions = [
        `Établissement de santé (clinique, hôpital)`,
        `Un médecin`,
        `Laboratoire d’analyses`,
        `Cabinet médical`,
        `Distributeur / revendeur`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const equipmentTypeOptions = [
        `Matériel de diagnostic (ECG, échographes, oxymètres…)`,
        `Matériel médico-chirurgical (instruments, aspirateurs de mucosité, autoclaves…)`,
        `Mobilier médical (lits, fauteuils roulants, tables d’accouchement…)`,
        `Matériel de laboratoire (centrifugeuses, microscopes, appareils d’analyse…)`,
        `Réactifs et consommables de laboratoire`,
        `Consommables médicaux (gants, blouses, seringues, compresses…)`,
        `Matériel de radiologie et imagerie médicale`,
        `Équipements pour bloc opératoire`,
        `Matériel pour soins à domicile (tensiomètres, thermomètres, nébuliseurs…)`,
        `Produits et accessoires médicaux (sparadraps, paravents, boîtes à instruments…)`,
        `Maintenance ou pièces détachées biomédicales`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const servicesOptions = [
        `Livraison uniquement`,
        `Livraison + installation`,
        `Livraison + installation + maintenance`,
        `Aucun`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.equipementMedical.youAre}
        class=""
        let:field
        let:id
        label={`Vous êtes ?`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={youAreOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.equipementMedical.equipmentType}
        class=""
        let:field
        let:id
        label={`Matériel médical recherché`}
        helpLabel="Maximum 4 choix"
    >
        <MeltMultiSelect
            {form}
            {id}
            {field}
            max={4}
            options={equipmentTypeOptions}
            valueToOption={(v) => ({
                value: v,
                label: find(equipmentTypeOptions, (o) => o.value === v)?.label ?? '',
            })}
        />
    </Row>

    <Row
        {form}
        field={fields.equipementMedical.services}
        class=""
        let:field
        let:id
        label={`Souhaitez-vous également un service associé ?`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={servicesOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin, soyez le plus précis dans votre demande de devis"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin, soyez le plus précis dans votre demande`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
